import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import {baseUrl} from '../Univ.js';
function RFQList() {
    const [rfqData, setRfqData] = useState([]);
    useEffect(() => {
        fetchRFQData();
    }, []);
    function fetchRFQData() {
        axios.get(`${baseUrl}rfq/`)
            .then(response => {
                const transformedData = response.data.map(item => ({
                    id: item.id,
                    rfq_no: item.rfq_no,
                    rfq_date: item.rfq_date,
                    pr_no: item.pr?.pr_no,
                    requested_by: item.pr?.requested_by,
                    status: item.status,
                    addedby: item.addedby,
                    action: (
                        <Link
                            to={`/rfq-view/${item.id}/`}
                            className="btn btn-success btn-sm"
                        >
                            View
                        </Link>
                    )
                }));
                setRfqData(transformedData);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const columns = [
        {
            field: 'id',
            headerName: 'ID',
            width: 80
        },
        {
            field: 'rfq_no',
            headerName: 'RFQ No',
            width: 180
        },
        {
            field: 'rfq_date',
            headerName: 'RFQ Date',
            width: 140
        },
        {
            field: 'pr_no',
            headerName: 'PR No',
            width: 180
        },
        {
            field: 'requested_by',
            headerName: 'Requested By',
            width: 180
        },
        {
            field: 'addedby',
            headerName: 'Created By',
            width: 160
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 130,
            renderCell: (params) => (
                <span
                    className={
                        params.value === 'Closed'
                            ? 'badge bg-danger'
                            : params.value === 'Converted'
                                ? 'badge bg-success'
                                : 'badge bg-warning text-dark'
                    }
                >
          {params.value}
        </span>
            )
        }
    ];
    return (
        <section className="container mt-4">

            <div className="row">

                <h3
                    className="text-center"
                    style={{
                        color: 'black',
                        backgroundColor: '#e5eaef',
                        padding: '10px'
                    }}
                >

                    <i
                        className="fa-solid fa-list"
                        aria-hidden="true"
                        style={{color: 'red'}}
                    ></i>

                    {' '}RFQ List

                </h3>

                {rfqData.length > 0 ? (
                    <div
                        style={{
                            height: '100%',
                            width: '100%'
                        }}
                        className="mt-4"
                    >

                        <DataGrid
                            sx={{
                                boxShadow: 4,
                                border: 4,
                                borderColor: 'primary.light',
                                '& .MuiDataGrid-cell:hover': {
                                    color: 'primary.main',
                                },
                            }}
                            rows={rfqData}
                            columns={columns}
                            pageSize={10}
                            autoHeight
                            initialState={{
                                sorting: {
                                    sortModel: [{field: 'id', sort: 'desc'}],
                                },
                            }}
                        />

                    </div>
                ) : (
                    <div className="text-center mt-5">

                        <h5>No RFQ Found</h5>

                    </div>
                )}

            </div>

        </section>
    );
}
export default RFQList;